import apis from '../../api'

export const forgotPsw = (country_code, email) => apis.webappInstance.post('/api/v2/user/reset_password', { country_code, email })
